import styled from '@emotion/styled';
import type { MicrositeResponsiveImage } from '~/model';
import MicrositeResponsiveImg from '~/components/MicrositeResponsiveImg';
import { LoadPriority } from '~/hooks/useLoadPriority';

/* ── styled components ── */

const Wrapper = styled.div`
	padding: 0.75rem;
	background-color: white;
	color: black;
`;

const Container = styled.div`
	max-width: 1536px;
	margin-left: auto;
	margin-right: auto;
`;

const Header = styled.div`
	@media (min-width: 768px) {
		height: 100px;
		display: flex;
		flex-direction: column;
		justify-content: center;
	}
`;

const Title = styled.div`
	text-transform: uppercase;
	font-weight: 500;
	font-size: 1.5rem;
	line-height: 2rem;
	letter-spacing: 0.3em;
	text-align: center;
	@media (min-width: 768px) {
		font-size: 2.25rem;
		line-height: 2.5rem;
		padding-bottom: 0.5rem;
	}
`;

const Subtitle = styled.div`
	letter-spacing: 0.1em;
	text-align: center;
`;

const FloorItem = styled.div`
	max-width: 1024px;
	margin-left: auto;
	margin-right: auto;
`;
/* ── component ── */

export default function FloorplanBlockEta({ floors }: { floors: MicrositeResponsiveImage[] }) {
	if (floors.length === 0) {
		return null;
	}

	return (
		<Wrapper id="floors">
			<Container>
				<Header>
					<Title>Floor Plans</Title>
					<Subtitle>Tap any photo for a full screen slide show.</Subtitle>
				</Header>
				<div>
					{floors.map((floor, i) => (
						<FloorItem key={i}>
							<MicrositeResponsiveImg priority={LoadPriority.ON_LOAD} image={floor} />
						</FloorItem>
					))}
				</div>
			</Container>
		</Wrapper>
	);
}
